import type { AdminTheme } from '@/context/AdminThemeContext';

/** Shared admin shell class maps — light/dark scoped to admin only. */
export function adminShell(theme: AdminTheme) {
  const dark = theme === 'dark';
  return {
    page: dark ? 'min-h-screen bg-slate-950 text-slate-100' : 'min-h-screen bg-brand-surface text-brand-navy',
    sidebar: dark
      ? 'border-slate-800 bg-slate-900'
      : 'border-gray-200 bg-white shadow-sm',
    sidebarBorder: dark ? 'border-slate-800' : 'border-gray-200',
    sidebarLabel: dark ? 'text-slate-500' : 'text-brand-muted',
    navActive: 'bg-primary text-white shadow-sm',
    navIdle: dark
      ? 'text-slate-400 hover:bg-slate-800 hover:text-white'
      : 'text-brand-muted hover:bg-brand-surface hover:text-brand-navy',
    header: dark
      ? 'border-slate-800 bg-slate-900/95 text-slate-100'
      : 'border-gray-200 bg-white/95 text-brand-navy',
    headerSub: dark ? 'text-slate-500' : 'text-brand-muted',
    roleBadge: dark ? 'bg-primary/20 text-primary' : 'bg-primary/10 text-primary',
    outlineBtn: dark
      ? 'border-slate-700 bg-slate-800 text-white hover:bg-slate-700'
      : 'border-gray-200 bg-white text-brand-navy hover:bg-brand-surface',
    ghostBtn: dark
      ? 'text-slate-300 hover:bg-slate-800 hover:text-white'
      : 'text-brand-muted hover:bg-brand-surface hover:text-brand-navy',
    overlay: 'bg-black/50',
    card: dark
      ? 'border-slate-800 bg-slate-900 text-white'
      : 'border-gray-100 bg-white text-brand-navy shadow-soft',
    cardMuted: dark ? 'text-slate-400' : 'text-brand-muted',
    tableWrap: dark ? 'border-slate-800' : 'border-gray-100',
    tableHead: dark ? 'bg-slate-800/60 text-slate-400' : 'bg-brand-surface text-brand-muted',
    tableRow: dark ? 'border-slate-800 hover:bg-slate-800/40' : 'border-gray-100 hover:bg-brand-surface/80',
    tableCell: dark ? 'text-slate-200' : 'text-brand-navy',
    input: dark
      ? 'border-slate-700 bg-slate-800 text-white placeholder:text-slate-500 focus:border-primary focus:ring-primary/30'
      : 'border-gray-200 bg-white text-brand-navy placeholder:text-brand-muted focus:border-primary focus:ring-primary/30',
    select: dark
      ? 'border-slate-700 bg-slate-800 text-white focus:border-primary focus:ring-primary/30'
      : 'border-gray-200 bg-white text-brand-navy focus:border-primary focus:ring-primary/30',
    empty: dark ? 'text-slate-500' : 'text-brand-muted',
    mobileNav: dark ? 'border-slate-800 bg-slate-900' : 'border-gray-200 bg-white',
  };
}
